function sendCustomEvent(eventName: string, param: object) {
  const {dataLayer}: any = window
  if (dataLayer === undefined) return

  dataLayer.push({
    event: eventName,
    ...param,
  });
}

export default sendCustomEvent
